import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.894 4.929h-1.037a.786.786 0 0 0 0 1.571h1.037a.54.54 0 0 1 .534.534V12.3l-.88.44A2.6 2.6 0 0 0 18.758 12h-3.3a2.61 2.61 0 0 0-1.988.927 2.8 2.8 0 0 0-.636 1.43h-1.627c-.08-.52-.3-1.01-.636-1.414A2.6 2.6 0 0 0 8.543 12h-3.3a2.6 2.6 0 0 0-1.792.739l-.88-.44V7.034a.54.54 0 0 1 .535-.534h1.037a.786.786 0 0 0 0-1.571H3.106A2.106 2.106 0 0 0 1 7.034v5.752a.79.79 0 0 0 .432.699l1.234.62c-.107.37-.139.758-.095 1.14a4.41 4.41 0 0 0 4.322 3.826 4.36 4.36 0 0 0 4.125-3.142h1.768a.8.8 0 0 0 .196-.04 4.345 4.345 0 0 0 4.125 3.182 4.41 4.41 0 0 0 4.321-3.826c.055-.38.034-.767-.062-1.14l1.233-.62a.79.79 0 0 0 .4-.7v-5.75a2.106 2.106 0 0 0-2.105-2.106M6.893 17.5a2.84 2.84 0 0 1-2.75-2.499 1.32 1.32 0 0 1 .29-1.052 1.02 1.02 0 0 1 .786-.377h3.3a1.02 1.02 0 0 1 .786.377A1.32 1.32 0 0 1 9.643 15a2.836 2.836 0 0 1-2.75 2.499m12.964-2.499a2.75 2.75 0 1 1-5.5 0 1.32 1.32 0 0 1 .29-1.052 1.02 1.02 0 0 1 .787-.377h3.3a1.02 1.02 0 0 1 .785.377A1.32 1.32 0 0 1 19.857 15"
    }, null, -1)
  ]))]))
}
export default { render: render }